import { FilterDTO } from '@apia/components';
import {} from '@apia/components/src/components';
import { createContext, FC } from 'react';
import { TReference } from '../../chat';

export type TSearchListItem = {
  content: string;
  isExternal: boolean;
  link: string;
  title: string;
  references: TReference[];
};

export interface ProcessingUnit {
  visualizationType: TSearchMode;
  content: string;
  references: TReference[];
  isExternal: boolean;
}

export interface ListingProcessingUnit extends ProcessingUnit {
  visualizationType: 'list';
  title: string;
  link: string;
}

export interface ChatProcessingUnit extends ProcessingUnit {
  visualizationType: 'chat';
}

export const ViewRendererContext = createContext<ISemanticSearchViewController>(
  {} as any,
);

export type TSearchMode = 'list' | 'chat' | 'none';

export interface ISemanticSearchViewController {
  state: {
    filters: Record<string, FilterDTO>;
    filtersOpen: boolean;
    isLoading: boolean;
    mode: TSearchMode;
    searchString: string;
  };

  ResultsRenderer: FC;
  clearHistory(): Promise<void>;
  search(str?: string): void;
  toggleFiltersOpen(): void;
}

export type TResponseData = {
  result: string;
  success: string;
  streaming: boolean;
  failed?: boolean;
  messageFooter?: string;
  messageHeader?: string;
  hideFeedback?: string;
};

export interface ISearchResultsController<P extends ProcessingUnit> {
  state: {
    results: P[];
  };

  beforeSearch(props?: object): void;
  afterSearch(props?: object): void;

  clear(): void;

  processResults(
    qryString: string,
    results: ProcessingUnit[],
    responseData?: TResponseData,
  ): void;

  Component: FC;
}
